<template>
  <a-range-picker
    style="width: 100%"
    v-model="value"
    allowClear
    v-bind="$attrs"
    @change="change"></a-range-picker>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    start: {
      type: [String, Number],
      default: null
    },
    end: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      value: this.start ? [this.start, this.end] : []
    }
  },
  watch: {
    start (value) {
      this.value = value ? [value, this.end] : []
    },
    end (value) {
      this.value = this.start ? [this.start, value] : []
    }
  },
  methods: {
    moment,
    change (e) {
      console.log(e)
      if (e.length) {
        this.$emit('update:start', moment(e[0]).format('YYYY-MM-DD 00:00:00'))
        this.$emit('update:end', moment(e[1]).format('YYYY-MM-DD 23:59:59'))
      } else {
        this.$emit('update:start', null)
        this.$emit('update:end', null)
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
